export default {"src":"/_next/static/media/img_linkedin_4_2.e9ea3d0a.svg","height":740,"width":720,"blurWidth":0,"blurHeight":0};